import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { ReportIssues, ReportIssueTypes } from '@/constants/reports'
import { Issue } from '@/types'

export enum ServiceRequestPageView {
    UPDATE_USERPROFILE = 'UPDATE_USERPROFILE',
    REPORT_ISSUE = 'REPORT_ISSUE',
    REPORTS_LIST = 'REPORTS_LIST',
    REQUEST_SERVICE = 'REQUEST_SERVICE',
    SERVICES_LIST = 'SERVICES_LIST',
}

export enum ServiceOption {
    SERVICE_CONNECTION = 'SERVICE_CONNECTION',
    CHECK_SERVICE_REQUEST_PROGRESS = 'CHECK_SERVICE_REQUEST_PROGRESS',
    CHANGE_ACCOUNT_DETAILS = 'CHANGE_ACCOUNT_DETAILS',
    STATEMENT_REQUEST = 'STATEMENT_REQUEST',
    TEMPORARY_DISCONNECTION = 'TEMPORARY_DISCONNECTION',
    METER_TRANSFER = 'METER_TRANSFER',
}

export enum ReportOption {
    FAULTY_METER = 'FAULTY_METER',
    ISSUE_WITH_POSTPAID_BILL = 'ISSUE_WITH_POSTPAID_BILL',
    ILLEGAL_CONNECTION = 'ILLEGAL_CONNECTION',
    STOLEN_METER = 'STOLEN_METER',
}

export interface ServiceRequestPageState {
    currentView: ServiceRequestPageView | null
    selectedIssue: Issue
}

const initialState: ServiceRequestPageState = {
    currentView: null,
    selectedIssue: ReportIssues[ReportIssueTypes.REPORT_ISSUE_WITH_POSTPAID_BILL],
}

export const serviceRequestPageSlice = createSlice({
    name: 'serviceRequestPage',
    initialState,
    reducers: {
        setState: (state, action: PayloadAction<Partial<ServiceRequestPageState>>) => {
            state.currentView = action.payload.currentView ?? state.currentView
            state.selectedIssue = action.payload.selectedIssue ?? state.selectedIssue
        },
        resetState: () => initialState,
    },
})

export const serviceRequestPageActions = serviceRequestPageSlice.actions
export type ServiceRequestPageActions = typeof serviceRequestPageActions
export default serviceRequestPageSlice.reducer
